// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3B9Wi","col":"styles_col__2eXW3"};